import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { isRTL } from "../../../utils";

export const GroupsLinkApi = createApi({
  reducerPath: "GroupsLink",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND3_URL,
    prepareHeaders: (headers) => {
      headers.set("accept-language", isRTL ? "ar" : "en");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getGroupLinkOptions: builder.query({
      query: ({ entityType }) =>
        `/groups/link/entities/${entityType}?dropdown=true`,
    }),
    getGroupLinkedItems: builder.query({
      query: ({ groupId, entityType }) =>
        `/groups/link/${groupId}/${entityType}`,
    }),
    linkGroupEntity: builder.mutation({
      query: ({ groupId, entityType, entityId }) => ({
        url: `/groups/link/${groupId}/${entityType}/${entityId}`,
        method: "POST",
      }),
    }),
    unlinkGroupEntity: builder.mutation({
      query: ({ groupId, entityType, entityId }) => ({
        url: `/groups/link/${groupId}/${entityType}/${entityId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetGroupLinkOptionsQuery,
  useGetGroupLinkedItemsQuery,
  useLinkGroupEntityMutation,
  useUnlinkGroupEntityMutation,
} = GroupsLinkApi;
